/**
 * Returns a boolean value, using fallback if primary is undefined or null
 *
 * @param fallback - The fallback boolean value to use if primary is undefined or null
 * @param primary - The primary boolean value to use if defined
 * @returns {Boolean} - The boolean value based on primary or fallback
 */
export const fallbackBool = (
  fallback: boolean,
  primary: boolean | null | undefined,
): boolean =>
  primary === undefined || primary === null ? fallback : primary;
